<template>
  <div class="events">
    <div class="count-events">
      <!-- {{ totalEvents }} {{ $t(`dash.inbox.event.total${totalEvents > 1 ? 's' : ''}`) }} -->
      <div class="choice all">
        <Checkbox :id="'selectEventInbox'" :isChecked="multiTask.length >= 1" :isLine="multiTask.length > 0 && !multiTaskAll" :isDisable="!list || list.length == 0" :add="selectAllEvents" :remove="deselectAllEvents"></Checkbox>
        <div v-if="isLoading" class="field">Recherche de contenu</div>
        <div v-else class="field">{{ totalEvents }} {{ $t(`dash.inbox.event.total${totalEvents > 1 ? 's' : ''}`) }} {{ multiTask.length ? `(${multiTaskAll ? totalEvents : multiTask.length})` : '' }}</div>
      </div>
      <div class="cta" v-if="multiTask.length">
        <div class="affected_to">
          <Tooltip :text="$t('dash.inbox.tooltip.person_add')" position="top">
            <span @click="openPopupSelectUsersMultiTask()">
              <i class="fa-solid fa-user-plus"></i>
              Assigner
            </span>
        
          </Tooltip>

        </div>
        <div class="state">
          <Tooltip :text="$t('dash.inbox.tooltip.playlist_add_check')" position="top" >
            <span @click="changeMultiTask({ status: '1'})">
              <i class="fa-regular fa-clipboard-check"></i>
              Traité
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
    <ul ref="listEventScrool">
      <template v-if="list && list.length">
        <li v-for="(event, key) in getFilterList" :key="'event-'+key" class="event card" :class="`event-${key} ${selected && selected._id == event._id ? 'selected' : ''} ${multiTask && multiTask.length ? 'active-multi-choices' : ''}`"  @click="selectEvent(event)">

          <header>
          
            <div class="context">
              <div class="choice" @click.stop="" :class="{selected:multiTask.includes(event._id)}">
                <Checkbox :id="event._id" :isChecked="multiTask.includes(event._id)" :add="addSelectEvent" :remove="removeSelectEvent"></Checkbox>
              </div>
              <Avatar :typeNetwork="pages.find(p => p.network_id == event.page && p.network == event.network).network" :urlPicture="pages.find(p => p.network_id == event.page && p.network == event.network).avatar"></Avatar>
              <p>
                <span class="page-name">{{ pages.find(p => p.network_id == event.page && p.network == event.network).name }}</span>
                -
                <span class="bold">{{ $t(`dash.inbox.type.${event.type}`).split(" ")[0]}}</span>
                {{ $t(`dash.inbox.type.${event.type}`).split(" ").slice(1,$t(`dash.inbox.type.${event.type}`).split(" ").length).join(" ")}}
              </p>
            </div>
            <div class="actions">
              <!-- <div class="state">{{ [1, 3].includes(event.status) ? $t('dash.inbox.state.treated') : $t('dash.inbox.state.waiting') }}</div> -->
              <div class="state" v-if="parseInt(event.status) == 4">{{ $t('dash.inbox.state.removed') }}</div>
              <div class="state" v-else-if="parseInt(event.status) == 5">{{ $t('dash.inbox.state.hided') }}</div>
              <div class="state" v-else @click="changeEvent(event._id, { status: getChangeStatus(event.status)})">
                {{ [1, 3].includes(parseInt(event.status)) ? $t('dash.inbox.state.treated') : $t('dash.inbox.state.waiting') }}
              </div>
              <div class="flag" :class="[{active: event.flag}]" @click="changeEvent(event._id, { flag: event.flag ? 'false' : 'true'})">
                <i class="fa-solid fa-flag"></i>
              </div>
            </div>
          </header>
          <div class="content">
            <div class="image-avatar">
                <a @click="getDirectLink(event)">
                  <img v-if="event.network == 'linkedin' && event.user && linkedinLogoUrl(event.user.logoV2)" :src="linkedinLogoUrl(event.user.logoV2)" @error="avatarFallback"/>
                  <img v-else-if="event.user && event.user.picture && event.user.picture.data" :src="event.user.picture.data.url"/>
                  <img src="img/avatar.jpg" v-else/>
                </a>
            </div>

            <div class="container-content-event">
              <div class="content-event">
                
              <div class="title">
                <!-- <a :href="getDirectLink(event)" target="_blank"> -->
                <a @click="getDirectLink(event)"> 
                  {{ getUsernameEvent(event) }}
                </a>        
                {{$t(`dash.inbox.content.${event.type}.title.${event.network}` + (event.type == 'reaction' && event.data.changes && event.data.changes.value && event.data.changes.value.comment_id  ? '.comment' : '')) }} {{ event.type == 'reaction' ? event.data.changes.value.reaction_type : ( event.type == 'message-reaction' ? event.data.messaging.reaction.emoji : '') }}
              </div>
              <template v-if="event.type == 'rating'">
                <div class="message">
                  {{ `${$t(`dash.inbox.content.rating.detail.recommendation_type`)} : ${event.data.changes.value.recommendation_type}` }} <br/>
                  {{ `${$t(`dash.inbox.content.rating.detail.review_text`)} : ${event.data.changes.value.review_text}` }}
                </div>
              </template>
              <template v-else-if="event.network == 'linkedin'">
                <div class="message" v-if="event.type == 'comment' && event.data.decoratedGeneratedActivity" v-html="messagePostFormatLinkedin(event.data.decoratedGeneratedActivity.comment.text)"></div>  
                <div class="message" v-else-if="event.type == 'comment' && event.data.detail && event.data.detail.comment" v-html="messagePostFormatLinkedin(event.data.detail.comment.message.text)"></div>  
                <div class="message" v-else-if="event.type == 'mention' && event.data.decoratedGeneratedActivity" v-html="messagePostFormatLinkedin(event.data.decoratedGeneratedActivity.share.text)"></div> 
                <div class="message" v-else-if="event.type == 'message' && event.data.messages && event.data.messages.elements && event.data.messages.elements.length && event.data.messages.elements[0].body && event.data.messages.elements[0].body.text" v-html="messagePostFormatLinkedin(event.data.messages.elements[0].body.text)"></div> 
              </template>
              <template v-else-if="event.network == 'tiktok'">
                <div class="message" v-if="event.data.comment">
                  {{ event.data.comment.text }}
                </div>
              </template>
              <template v-else-if="['mention', 'post', 'status', 'photo', 'video', 'share', 'comment'].includes(event.type)">
                <div class="message">
                  {{ event.data.changes.value.message || event.data.changes.value.text }}
                </div>  
              </template>
              <template v-else-if="event.type == 'message'">
                <div class="message">
                  {{ event.data.messaging.message.text }}
                </div>  
              </template>
              </div>
              <div class="footer">
                <div class="left">
                  <div class="affected_to">
                      <div class="list">
                        <template v-for="(user, index) in (event.affected_to ? event.affected_to.slice(0,10) : [])"  v-if="findUser(user)">
                          <Tooltip :text="`${findUser(user).lastname} ${findUser(user).firstname} (${findUser(user).email})`" :key="index">
                            <img class="image-user" v-if="!findUser(user).avatar || !findUser(user).avatar.length" :src="require('../../../assets/img/ico-man.svg')"/>
                            <img class="image-user" v-else-if="findUser(user).avatar && !!findUser(user).avatar.length" :src="findUser(user).avatar"/>
                          </Tooltip>
                        </template>
                      
                        <div class="add-user" @click="popupSelectUsers = true">
                          <i v-if="event.affected_to.length < 10" class="fa-solid fa-user-plus"></i>
                          <p v-else>+{{event.affected_to.length - 10}}</p>
                        </div>  
                      </div>
                  </div>
                </div>
                <div class="right">
                  <ContextMenu :options="[
                    {name :'good',label: `<div class='badge-evaluation good'>${$t('dash.inbox.filter.evaluation.good')}</div>`},
                    {name :'normal',label: `<div class='badge-evaluation normal'>${$t('dash.inbox.filter.evaluation.normal')}</div>`},
                    {name :'bad',label: `<div class='badge-evaluation bad'>${$t('dash.inbox.filter.evaluation.bad')}</div>`},
                    {name :'none',label: `<div class='badge-evaluation none'>${$t('dash.inbox.filter.evaluation.none')}</div>`},
                    ]" :addClass="'context-menu-evaluation'" :id="event._id" v-on:clickOption="changeEvaluation">

                    <div class="notation">
                      <i v-if="event.evaluation == 1" class="fa-solid fa-face-frown" style="color: #FF5C5C;"></i>
                      <i v-else-if="event.evaluation == 2" class="fa-solid fa-face-smile" style="color: #FFC93D;"></i>
                      <i v-else-if="event.evaluation == 3" class="fa-solid fa-face-laugh" style="color: #1CD185;"></i>
                      <i v-else class="fa-solid fa-face-meh" style="color: #9FA4A8;"></i>
                      <!-- <span class="material-icons sentiment_very_satisfied" :class="[{active: event.evaluation == 3}]" @click="changeEvent(event._id, { evaluation: '3' })">sentiment_very_satisfied</span> -->
                    </div>
                  </ContextMenu>
                  
                  <div class="date">{{ formatDate(event.date) }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- {{ event }}  -->
        </li> 
      </template>
      <template v-else-if="!isLoading || pages.length == 0" >
        <li class="card-none-event">
          <div class="text">
            <h4>
              Aucun resultat
              <i class="fa-solid fa-magnifying-glass"></i>
            </h4>
            <p>
              Les paramètres de votre filtre ne correspondent à aucun événement
            </p>
          </div>
        </li> 
      </template>
      <li v-for="index in (isLoading ? 5 : list && list.length < totalEvents ? 1 : 0)" :key="'event-loading-'+index" class="event card loading-content wave-effect" v-show="isLoading && pages.length">
        <header>
        </header>
        <div class="content">

          <div class="image-avatar">
              <a>
                <img class="wave-effect" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC">             
              </a>
          </div>

          <div class="container-content-event">
            <div class="content-event">
            
            <div class="title">
              <!-- <a :href="getDirectLink(event)" target="_blank"> -->
              <a class="wave-effect">wwwwwww</a>        
          
            </div>
            
              <div class="message">
                <span class="wave-effect">{{'w'.repeat(Math.random()*50) }}</span>
              </div>
        
            </div>
            <div class="footer">
              <div class="left">
                <div class="affected_to">
                    <div class="list">
                      
                      <img v-for="index2 in Math.floor(Math.random() * 5) + 1" :key="'event-loading'+index+'-image-user'+index2" class="image-user wave-effect" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC"/>

                    </div>
                </div>
              </div>
              <div class="right">
          
        
                
                <div class="date wave-effect">wwwwwwww</div>
              </div>
            </div>
          </div>
        

        </div>
     
        <!-- {{ event }}  -->
      </li> 
    </ul>
    <vs-popup class="overlay groups shared-planner affected_to" 
              :title="$t('dash.inbox.event.affected_to.title')" 
              :active.sync="popupSelectUsers">
              
      <component-users-selector
        v-if="popupSelectUsers"
        :usersAdded="usersAdded"
        v-on:submit="addAffectedToEvent"
      ></component-users-selector>

    </vs-popup>

    <vs-popup class="overlay groups shared-planner affected_to" 
          :title="$t('dash.inbox.event.affected_to.title')" 
          :active.sync="popupSelectUsersMultiTask">
        <component-users-selector
          v-if="popupSelectUsersMultiTask"
          :usersAdded="[]"
          v-on:submit="addAffectedToMultiTask"
        ></component-users-selector>

      </vs-popup>

  </div>
</template>

<script>
import moment from 'moment'
import Moderation from './../../mixins/Moderation'
import Tooltip from './../tooltip/tooltipInit'
import PageImageAvatar from './../PageImageAvatar'
import { ObserveVisibility } from 'vue-observe-visibility'
import componentUsersSelector from './../overlay/UsersSelector'
import componentLoader from './../overlay/Loader'
import Popup from '../../../utils/Popup'

import Avatar from './../utils/avatar.vue';
import Checkbox from './../utils/checkbox.vue';
import ContextMenu from './../contextMenu/contextMenuInit.vue'

const translateFilter = {
  good : 3,
  normal : 2,
  bad : 1,
  none : 0,
}

export default {
  name: 'component-list-inbox',

  mixins: [Moderation],

  components: {
    Tooltip,
    PageImageAvatar,
    componentUsersSelector,
    componentLoader,
    Avatar,
    Checkbox,
    ContextMenu
  },

  directives: {
    ObserveVisibility
  },

  props: {
    page: Object,
    pages: Array,
    list: Array,
    totalEvents: Number,
    totalAllEvents: Number,
    selected: Object,
    textFilter: String,
    isLoading : {
      type: Boolean,
      default: false,
    },
    filter: Object,
  },

  data(){
    return {
      popupSelectUsers: false,
      popupSelectUsersMultiTask: false,
      multiTask: [],
      multiTaskAll: false
    }
  },

  computed: {
    allUsers() {
      return JSON.parse(localStorage.users)
    },

    usersAdded() {
      console.log(this.selected.affected_to)
      return this.selected.affected_to ? this.selected.affected_to.map(u => this.findUser(u)).filter(u => u) : []
    },

    getFilterList() {
      let filterStatus = this.filter.status
      if(this.filter.flag){
        if(!filterStatus.includes(2)) filterStatus.push(2)
        if(!filterStatus.includes(3)) filterStatus.push(3)
      }

      return this.list.slice().filter(event =>
        (this.filter.userId || this.filter.status.length == 0 || this.filter.status.includes(event.status))
          && (!this.textFilter
                || (event.user && event.user.name && event.user.name.toLowerCase().includes(this.textFilter.toLowerCase()))
                || (event.user && event.user.username && event.user.username.toLowerCase().includes(this.textFilter.toLowerCase()))
                || (event.data.changes && event.data.changes.value && event.data.changes.value.message && event.data.changes.value.message.toLowerCase().includes(this.textFilter.toLowerCase())))
    )
    }
  },

  mounted() {

  },

  watch: {
    multiTask: {
      async handler(val, oldVal){
        if(this.multiTaskAll && oldVal.length > val.length)
          this.multiTaskAll = false   
      },
      deep: true
    },

    list(newList){
      console.log('list watcher')
      if (this.multiTaskAll) {
        newList.forEach(e => { if (!this.multiTask.includes(e._id)) this.multiTask.push(e._id) })
      } else {
        const newIds = new Set(newList.map(e => e._id))
        this.multiTask = this.multiTask.filter(id => newIds.has(id))
      }

      // if (this.list.length < this.totalEvents) {
      if (this.list.length < this.totalAllEvents) {
        this.$refs.listEventScrool.addEventListener('scroll', this.handleScroll);
      }else{
        this.$refs.listEventScrool.removeEventListener('scroll', this.handleScroll);
      }
    }
  },

  methods: {

    messagePostFormatLinkedin(text) {
        // Ajouter un espace devant les https/http si aucun espace n'est présent juste avant
        // Ajouter un espace devant les www si aucun // ou espace n'est présent juste avant
        text = text.replace(/(?<!\s)(https?:\/\/)|(?<!\/\/|[^\/]\s)(www\.)/g, " $1$2") // eslint-disable-line
             
        let replacePattern = /@\[(.*?)\]\(urn:li:*?:(.*?)\)/gim; // eslint-disable-line
        text = text.replace(replacePattern, '<b>$1</b>');

        // {hashtag|\#|modération}
        replacePattern = /\{hashtag\|\\#\|(.*?)\}/gim // eslint-disable-line
        text = text.replace(replacePattern, '<b>#$1</b>');

        return text.trim();
    },


    selectAllEvents() {
      this.multiTask = this.list.map(e => e._id)
      this.multiTaskAll = true
      this.$forceUpdate()
    },

    deselectAllEvents() {
      this.multiTask = []
      this.multiTaskAll = false
      this.$forceUpdate()
    },

    addSelectEvent(idEvent) {
      if(!this.multiTask.includes(idEvent)) {
          this.multiTask.push(idEvent)
      }
    },

    removeSelectEvent(idEvent) {
      this.multiTask = this.multiTask.filter(id => id !== idEvent)
    },

    getChangeStatus(status=null){
      console.log('getChangeStatus', status)      
      switch(status){
        case 0:
          return '1'
        case 1:
          return '0'
        case 2:
          return '3'
        case 3:
          return '2'
      }
    },

    getUsernameEvent(event) {
      if(event.network == 'linkedin') {
        const name = event.user && (event.user.localizedName || event.user.name)
        if(name) return name
        return event.user && event.user.private ? this.$t('dash.inbox.linkedin.private-member') : event.userId
      }
      if(event.network == 'tiktok') return (event.user && event.user.name) ? event.user.name : ((event.data && event.data.comment && event.data.comment.user && event.data.comment.user.name) ? event.data.comment.user.name : event.userId)
      return event.user.name || event.user.username || (event.data.changes && event.data.changes.value.from && event.data.changes.value.from.username  ? event.data.changes.value.from.username : (event.data.changes && event.data.changes.value && event.data.changes.value.from && event.data.changes.value.from.name ? event.data.changes.value.from.name : event.userId))
    },
    openPopupSelectUsersMultiTask() {
      this.popupSelectUsersMultiTask = true
    },

    visibilityChanged (isVisible, entry) {
      // console.log('visibilityChanged', isVisible, entry)
      if(isVisible){
        let idEvent = parseInt(entry.target.classList[1].replace('event-', ''))
        // if(idEvent == this.list.length - 1 && idEvent < this.totalEvents - 1){
        if(idEvent == this.list.length - 1 && idEvent < this.totalAllEvents - 1){
          console.log('FIN')
          this.$emit('nextEvents', { from: this.list.length})
        }
      }
    },

    findUser(id) {
      return this.allUsers.find(u => u.id == id)
    },

    async addAffectedToEvent(users) {
      await this.changeEvent(this.selected._id, {affected_to: users.map(u => u.id)})
      this.popupSelectUsers = false
    },

    async addAffectedToMultiTask(users) {
      if(this.multiTask.length) {
        this.$emit('changeMultiTask', {affected_to: users.map(u => u.id)}, this.multiTaskAll, this.multiTask)

      }
      this.popupSelectUsersMultiTask = false
    },

    async changeEvent(id, body) {
      // if(this.selected && this.selected._id == id)
      this.$emit('change', id, body)
      // this.$forceUpdate()
    },

    async changeMultiTask(body) {
      console.log("changeMultiTask",this.multiTask)
      if(this.multiTask.length) {
        this.$emit('changeMultiTask', body, this.multiTaskAll, this.multiTask)
      }
    },

    selectEvent(event) {
      this.$emit('select', event)
    },

    formatDate(dateToFormat) {
      let format = moment.unix(dateToFormat)
        .local()
        .format('DD/MM/YY HH:mm')
      return format
    },

    getDirectLink(event) {
      if(event.network == 'instagram') {
        return event.user && event.user.username ? Popup.open(`https://www.instagram.com/${event.user.username}`, '', 900, 700) : null
      }
      else if(event.network == 'linkedin') {
        let link = `https://www.linkedin.com/feed/update/${event.data.sourcePost}`
        if(event.type == 'comment')
          link += `?commentUrn=${encodeURIComponent(event.data.generatedActivity)}`
        else if(event.type == 'message')
          link = event.data.conversationUrl
        return  Popup.open(link, '', 900, 700) 
      }
      else if(event.network == 'tiktok') {
        let itemId = event.data && event.data.item ? event.data.item.itemId : null
        let handle = event.user && event.user.unique_id ? event.user.unique_id : 'user'
        return itemId ? Popup.open(`https://www.tiktok.com/@${handle}/video/${itemId}`, '', 900, 700) : null
      }


      let url = `https://www.facebook.com/`
      switch(event.type) {
        case 'rating':
          url = `https://www.facebook.com/${event.data.changes.value.open_graph_story_id}`
          break
        case 'mention':
        case 'message':
        case 'message-reaction':
          url = event.user.link
          break
        case 'status':
          url = `https://www.facebook.com/${event.data.changes.value.post_id}`
          break
        case 'comment':
          url = `https://www.facebook.com/${event.data.changes.value.comment_id}`
          break
      }
      // return url
      Popup.open(url, '', 900, 700)
    },
    
    changeEvaluation(idEvent, value) {
      console.log("changeEvaluation",idEvent, value)
      this.changeEvent(idEvent, { evaluation: translateFilter[value]})
    },

    handleScroll(e) { 
      console.log("handleScrol")
      if (e.target.scrollHeight - e.target.offsetHeight - e.target.scrollTop < 150) {
        console.log("handleScrol1")
        // if(this.list.length < this.totalEvents){
        if(this.list.length < this.totalAllEvents){
            console.log("handleScrol2")
            this.$emit('nextEvents', { from: this.list.length})
            // this.$emit('nextEvents')
            this.$refs.listEventScrool.removeEventListener('scroll', this.handleScroll);
        }else{
          this.$refs.listEventScrool.removeEventListener('scroll', this.handleScroll);
        }
      }
    },
   
  },

  beforeDestroy() {
    this.$refs.listEventScrool.removeEventListener('scroll', this.handleScroll);
  },

}    
</script>
